<div class="main" style="min-height: 100vh;">
  <div class="col-8 main-left">
    <app-artiles-all></app-artiles-all>
  </div>
  <div class="col-4 main-right">
    <app-editors-choice-comp></app-editors-choice-comp>
  </div>
</div>
